import React from 'react';

import { useTranslations } from 'next-intl';

import EndedIcon from '@/assets/icons/presale-ended.svg';
import { P } from '@/components/shared/Typography';

function PresaleEnded() {
  const t = useTranslations('pools');

  return (
    <div className="bg-background flex justify-between px-7 py-6">
      <div className="flex flex-col justify-center ">
        <P className="text-lg font-semibold ">{t('presaleEnded')}</P>
        <P className="text-sm font-normal text-muted-foreground">
          {t('poolNowLive')}
        </P>
      </div>
      <div className="">
        <EndedIcon />
      </div>
    </div>
  );
}

export default PresaleEnded;
